<script>
  import Contents from 'src/pc/pages/NewsCate'
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import PostContainer from '../components/PostContainer'
  import DropDown from '../components/Dropdown'
  export default {
    extends: Contents,
    components: {
      PageLayout,
      SubPageLayout,
      DisplayContainer,
      PostContainer,
      DropDown
    },
    computed: {
      getAccess() {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .contents {
    top: 0 !important;
  }
  .dp_top {
    margin-top: 0 !important;
    margin-bottom: 30px !important;
  }
  .dp_top img {
    max-width: 100%;
    height: auto !important;
  }
  .contents .normal .category {
    display: block;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 35px;
  }
  .contents .normal .category p {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
  }
  .contents .normal .category p.ctry_kr {
    font-family: 'Roboto Slab' ,'SUIT Variable';
    font-size: 27px;
    font-weight: 800;
  }

  .contents .display-container.title {
    width: 100vw;
    height: 100px;
  }
  .contents .title_top {
    width: 100vw;
    height: 100px;
    padding: 20px;
  }
  .contents .title_top:before {
    width: 32px;
    height: 32px;
    margin-right: 8px;
  }
  .contents .wsop .title_top:after {
    background: url(https://cdn.bluffcatch.com/post/20/contents/499/bg-wsop-m.jpg) no-repeat;
    background-size: cover;
  }
  .contents .title_top p {
    font-size: 34px;
  }
  .contents .title_top p.text {
    font-size: 16px;
    margin-top: 5px;
  }
  /* GTO Wiazrd */
  .contents .gto {
    height: 480px;
    padding: 35px 20px;
    background-size: 188px auto;
    background-position: 50% 65%;
    text-align: center;
  }
  .contents .gto .logo img {
    height: 20px;
  }
  .contents .gto .logo .bc {
    margin-right: 34px;
  }
  .contents .gto .logo .bc:after {
    font-size: 32px;
    color: rgba(255,255,255,0.9);
    right: -25px;
    transform: translate(0, -46%);
  }
  .contents .gto .slogan {
    font-size: 27px;
    margin-top: 25px;
    line-height: 1.35em;
  }
  .contents .gto .slogan span {
    display: block;
  }
  .contents .gto .btn {
    font-size: 18px;
    padding: 16px 45px;
    position: absolute;
    left: 50%;
    bottom: 42px;
    transform: translate(-50%,0);
  }
  .contents .gto .btn i {
    font-size: 11px;
    padding: 5px 13px;
  }
  .contents .crtn_top .title {
    font-size: 20px;
    line-height: 1.6em;
    margin: 15px 0;
    letter-spacing: -0.01em;
  }
  .contents .crtn_top .title:before {
    width: 28px;
    height: 30px;
    margin-right: 8px;
  }
  .contents .crtn_top .sect {
    display: block;
    width: 100%;
  }
  .contents .crtn_top .sect.left {
    padding-right: 0;
    margin-bottom: 10px;
  }
  .contents .crtn_top .sect.right {
    padding-left: 0;
  }
  .contents .crtn_top .sect .display-container .img {
    height: 58vw;
  }
  .contents .crtn_top .sect .display-container .subj {
    font-size: 17px;
    margin-top: 10px;
  }
  .contents .crtn_top .sect .display-container .category {
    font-size: 12px;
    margin-top: 10px;
  }
  .contents .poll .articles .lst > li {
    width: 100% !important;
    padding: 30px 20px !important;
    margin-bottom: 10px !important;
    border: 1px solid #ccc !important;
  }
  .contents .poll .articles .lst > li.max-value {
    width: 100% !important;
    padding: 15px 120px 15px 0 !important;
    margin-bottom: 0 !important;
    border: 0 !important;
    border-bottom: 1px solid #e5e5e5 !important;
  }
  .contents .poll .poll-tab {
    background: none;
    margin: 10px 0 20px 0;
  }
  .contents .poll .poll-tab a {
    font-size: 15px;
    height: 48px;
  }
  .contents .poll .poll-tab a:first-child {
    width: 65%;
  }
  .contents .poll .poll-tab a:last-child {
    width: 35%;
  }
  .contents .poll .poll-tab a.on {
    font-size: 17px;
    background: none;
  }
  .contents .poll .poll-tab a img {
    height: 12px;
    margin-left: 4px;
  }
  .contents .poll .poll-tab a.on img {
    height: 13px;
  }
  .contents .crtn_top .sect .display-container .txt {
    height: 100%;
    background: linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,1.0) 50%);
    padding: 25px 20px 25px 25px;
  }
  .contents .crtn_top .sect .display-container .category {
    font-size: 12px;
    margin-top: 10px;
    line-height: 1.2em;
    right: 20px;
    bottom: 25px;
  }
  
</style>
